import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  onClick,
  href,
  className = ''
}: ButtonProps) {
  const baseStyles = 'font-semibold rounded-full transition-all duration-300 hover:scale-105 hover:shadow-xl';
  const variants = {
    primary: 'bg-gradient-to-r from-magenta-500 to-pink-500 text-white shadow-lg',
    secondary: 'bg-white text-magenta-600 border-2 border-magenta-500 hover:bg-magenta-50'
  };
  const sizes = {
    sm: 'px-6 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg'
  };
  const handleClick = () => {
    if (href) {
      // Track InitiateCheckout event
      if (window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
          content_name: '30 Noches para Dormir en Paz',
          content_category: 'Digital Product',
          value: 14.97,
          currency: 'USD'
        });
      }
      // Open in same tab for better conversion
      window.open(href, '_self');
    } else if (onClick) {
      onClick();
    }
  };
  return <button onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-78">
      {children}
    </button>;
}